import type { LogFn } from "@/features/companion/lib/companionLogger";

export interface DispatchContext {
  payload: Record<string, unknown>;
  cpLog?: LogFn;
  source: string;
}

export function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === "object" ? (value as Record<string, unknown>) : {};
}
